import {marketplace as axios} from '../../../axios';
import {v4 as uuidv4} from 'uuid';

export class Customer {
  static async getCustomerByEmail(email) {
    try {
      const customers = await axios.get(
        `/customers?output_format=JSON&display=full&filter[email]=[${email}]`,
      );
      console.log('customers', customers);
      return customers;
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async getCustomerAddress(customerId) {
    try {
      const address = await axios.get(
        `/addresses?output_format=JSON&display=full&filter[id_customer]=[${customerId}]`,
      );
      console.log('address', address);
      return address;
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async createAddress(customerData) {
    const customerXML = `
            <prestashop>
                <address>
                    <id_country>${customerData.id_country}</id_country>
                    <alias>${customerData.alias}</alias>
                    <address1>${customerData.address1}</address1>
                    <city>${customerData.city}</city>
                    <firstname>${customerData.firstname}</firstname>
                    <lastname>${customerData.lastname}</lastname>
                    <id_customer>${customerData.id_customer}</id_customer>
                    <postcode>${customerData.postcode}</postcode>
                    <type>${customerData.type}</type>
                </address>
            </prestashop>
        `;

    try {
      const response = await axios.post(
        `/addresses?output_format=JSON`,
        customerXML,
      );
      console.log('response', response);

      return response;
    } catch (error) {
      console.error('Error creating customer:', error);
      throw error;
    }
  }

  static async updateAddress(customerData, addressIdDelivery) {
    const customerXML = `
            <prestashop>
                <address>
                    <id>${addressIdDelivery}</id>
                    <id_country>${customerData.id_country}</id_country>
                    <alias>${customerData.alias}</alias>
                    <address1>${customerData.address1}</address1>
                    <city>${customerData.city}</city>
                    <firstname>${customerData.firstname}</firstname>
                    <lastname>${customerData.lastname}</lastname>
                    <id_customer>${customerData.id_customer}</id_customer>
                    <postcode>${customerData.postcode}</postcode>
                    <type>${customerData.type}</type>
                </address>
            </prestashop>
        `;

    try {
      const response = await axios.put(
        `/addresses?output_format=JSON`,
        customerXML,
      );
      console.log('response', response);

      return response;
    } catch (error) {
      console.error('Error creating customer:', error);
      throw error;
    }
  }

  static async createCustomer(customerData) {
    const myUUID = uuidv4();
    const customerXML = `
            <prestashop>
                <customer>
                    <active>1</active>
                    <firstname>${customerData.firstname}</firstname>
                    <lastname>${customerData.lastname}</lastname>
                    <email>${customerData.email}</email>
                    <passwd>${myUUID}</passwd>
                    <id_default_group>3</id_default_group>
                    <!-- Add other fields as needed -->
                </customer>
            </prestashop>
        `;

    try {
      const response = await axios.post(
        `/customers?output_format=JSON`,
        customerXML,
      );
      console.log('response', response);

      return response;
    } catch (error) {
      console.error('Error creating customer:', error);
      throw error;
    }
  }

  // Function to create a new cart
  static async createCart(
    customerId,
    addressIdDelivery,
    productId,
    addressIdInvoice,
  ) {
    const cartData = `<prestashop>
            <cart>
              <id_currency>1</id_currency>
              <id_customer>${customerId}</id_customer>
              <id_address_delivery>${addressIdDelivery}</id_address_delivery>
              <id_address_invoice>${addressIdInvoice}</id_address_invoice>
              <id_lang>1</id_lang>
              <associations>
                  <cart_rows>
                    <cart_row>
                      <id_product>${productId}</id_product>
                      <id_product_attribute>0</id_product_attribute>
                      <id_address_delivery>${addressIdDelivery}</id_address_delivery>
                      <quantity>1</quantity>
                    </cart_row>
                  </cart_rows>
            </associations>
            </cart>
          </prestashop>`;

    const response = await axios
      .post(`/carts?output_format=JSON`, cartData)
      .catch(error => {
        console.error('Error creating cart:', error);
        throw error;
      });
    console.log('response', response);
    return response;
  }

  // Function to create a new order
  static async createOrder(
    cartId,
    customerId,
    addressIdDelivery,
    addressIdInvoice,
    total,
    external = false,
  ) {
    const orderData = `<prestashop>
            <order>
              <id_cart>${parseInt(cartId)}</id_cart>
              <id_customer>${parseInt(customerId)}</id_customer>
              <id_address_delivery>${parseInt(
                addressIdDelivery,
              )}</id_address_delivery>
              <id_address_invoice>${parseInt(
                addressIdInvoice,
              )}</id_address_invoice>
              <id_currency>1</id_currency>
              <id_lang>1</id_lang>
              <id_carrier>1</id_carrier>
              <module>${
                external ? 'ps_cashondelivery' : 'stripe_official'
              }</module>
              <payment>${external ? 'A la livraison' : 'CB'}</payment>
              <total_paid>${total ? total : 0}</total_paid>
              <total_paid_real>${total ? total : 0}</total_paid_real>
              <total_products>${total ? total : 0}</total_products>
              <total_products_wt>0</total_products_wt>
              <conversion_rate>1</conversion_rate>
            </order>
          </prestashop>`;

    return await axios.post(`/orders?output_format=JSON`, orderData);
  }

  static async sendForm(clientId, commandId, values) {
    const formData = `<prestashop>
                ${Object.entries(values)
                  .map(([key, value]) => {
                    return `<form_field_values>
                                <command_id>${commandId}</command_id>
                                <client_id>${clientId}</client_id>
                                <field_id>${key}</field_id>
                                 <value>${value}</value>
                            </form_field_values>`;
                  })
                  .join('')}
            
          </prestashop>`;

    console.log('formData', formData);
    const response = await axios.post(
      `/form_field_values?output_format=JSON`,
      formData,
    );
    return response;
  }

  static async sendFormFromCreateFromOld(clientId, commandId, values) {
    const formData = `<prestashop>
                ${values
        .map((item) => {
          return `<form_field_values>
                                <command_id>${commandId}</command_id>
                                <client_id>${clientId}</client_id>
                                <field_id>${item.field_id}</field_id>
                                 <value>${item.value}</value>
                            </form_field_values>`;
        })
        .join('')}
            
          </prestashop>`;

    console.log('formData', formData);
    const response = await axios.post(
        `/form_field_values?output_format=JSON`,
        formData,
    );
    return response;
  }

  static async sendFormFromArray(clientId, commandId, values) {
    console.log('values', values);
    const formData = `<prestashop>
                ${values
                  .map(item => {
                    return `<form_field_values>
                                <command_id>${commandId}</command_id>
                                <client_id>${clientId}</client_id>
                                <field_id>${item.field_id}</field_id>
                                 <value>${item.value}</value>
                            </form_field_values>`;
                  })
                  .join('')}
            
          </prestashop>`;

    console.log('formData', formData);
    const response = await axios.post(
      `/form_field_values?output_format=JSON`,
      formData,
    );
    return response;
  }

  static async getFormByOrder(orderId) {
    try {
      const form = await axios.get(
        `/form_field_values?output_format=JSON&display=full&filter[command_id]=${orderId}`,
      );
      console.log('form', form);
      return form;
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async getOrderById(orderId) {
    try {
      const order = await axios.get(
        `/orders/${orderId}?output_format=JSON&display=full`,
      );
      return order;
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async sendReport(id, order_id, customer_id, details) {
    const formData = `<prestashop xmlns:xlink="http://www.w3.org/1999/xlink">
            <reports>
                <order_id>${order_id}</order_id>
                <customer_id>${customer_id}</customer_id>
                <report>${id}</report>
                <details>${details}</details>
            </reports>
        </prestashop>`;

    console.log('formData', formData);
    const response = await axios.post(`/report?output_format=JSON`, formData);
    return response;
  }

  static async getStripeSessionLink(cartId, paymentId) {
    try {
      const response = await axios.get(
        `/stripe_session?cart_id=${cartId}&payment_type=${paymentId}`,
      );
      console.log('response', response);
      return response;
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async createQuote(productId, customerId, values) {
    try {
      const formData = Object.entries(values).map(([key, val]) => {
        let value = val;
        if (Array.isArray(val)) {
          value = val.filter(v => v !== false).join(', ');
        }

        return {[key]: value};
      });

      const response = await axios.post(`/send_quote`, {
        product: productId,
        customer: customerId,
        content: JSON.stringify(formData),
        status: 19,
      });
      console.log('response', response);
      return response;
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }
}
